import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { formatCurrency } from 'application/helpers'
import * as E from './releaseSectionElements'
import { ITheme } from 'application/utils/type'
import { formatDateToString } from 'application/helpers'

interface IInputDataProps {
  isExistingCar: boolean
  userFirstName: string
  leaseEndDate: Date
  oldOutOfPocketPerPay: number
  outOfPocketPerPay: number
  theme: ITheme
}

interface IReleaseCardItemDataProps {
  heading: string
  text: string
  amount: number
  id: string
}

const ReleaseSection = ({
  isExistingCar,
  userFirstName,
  leaseEndDate,
  oldOutOfPocketPerPay,
  outOfPocketPerPay,
  theme,
}: IInputDataProps) => {
  let difference: number = Math.abs(oldOutOfPocketPerPay - outOfPocketPerPay)

  const ReleaseCardItem = ({
    heading,
    text,
    amount,
    id,
  }: IReleaseCardItemDataProps) => {
    let headingid = `releasecard.${id}.heading`
    let textid = `releasecard.${id}.text`
    let amountid = `releasecard.${id}.amount`

    return (
      <div>
        <E.releaseCardHeading theme={theme} id={headingid}>
          {heading}
        </E.releaseCardHeading>
        <E.releaseCardDetailLine>
          <E.releaseCardDetailTextSpan id={textid}>
            {text}
          </E.releaseCardDetailTextSpan>
          <span id={amountid}>{formatCurrency(amount)}</span>
        </E.releaseCardDetailLine>
      </div>
    )
  }

  const ValuesDiv = () => {
    return (
      <E.releaseCard theme={theme}>
        <Row>
          <E.releaseCardLeftBorder
            isExistingCar={isExistingCar}
            theme={theme}
          />
          <E.releaseCardContent isExistingCar={isExistingCar} theme={theme}>
            <ReleaseCardItem
              heading={isExistingCar ? 'Existing lease' : 'Existing car'}
              text="How much comes out of your take home pay:"
              amount={oldOutOfPocketPerPay}
              id="existing"
            />
            <ReleaseCardItem
              heading={isExistingCar ? 'New lease' : 'New car'}
              text="How much comes out of your take home pay:"
              amount={outOfPocketPerPay}
              id="new"
            />
            <ReleaseCardItem
              heading="Difference per pay"
              text="The difference between your current lease and this one:"
              amount={difference}
              id="difference"
            />
          </E.releaseCardContent>
        </Row>
      </E.releaseCard>
    )
  }

  return (
    <E.releaseSection theme={theme}>
      <Container className="section pt-3 pb-3 text-center">
        <E.releaseHeader theme={theme}>
          {"Here's how " +
            (isExistingCar ? 'this new lease' : 'your upgrade ') +
            ' compares with your current lease'}
        </E.releaseHeader>
        <E.releaseSubText theme={theme}>
          {userFirstName +
            ', knowing your lease on your current vehicle is due to end ' +
            (isExistingCar && leaseEndDate
              ? `on ${formatDateToString(leaseEndDate, ' ')} `
              : `soon `) +
            '- your decision on what to do next is an important one. Take a look below at how this lease compares with your current lease -'}
        </E.releaseSubText>
        <ValuesDiv />
        <E.releaseSubText className="mt-3" theme={theme}>
          {'As you can see ' +
            userFirstName +
            ', for ' +
            formatCurrency(difference) +
            (oldOutOfPocketPerPay < outOfPocketPerPay ? ' more' : ' less') +
            ', you can ' +
            (isExistingCar
              ? 'keep your current car!'
              : 'potentially acquire a new car!')}
        </E.releaseSubText>
      </Container>
    </E.releaseSection>
  )
}

export default ReleaseSection
